import React, { useState, useRef, useCallback } from "react";
import { motion } from "framer-motion";
import CertificateCarousel from "./CertificateCarousel";
import CertificateViewer from "./CertificateViewer";

const AffiliationAccreditation = () => {
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const lastActiveElementRef = useRef(null);

  const handleSelectCertificate = useCallback((cert) => {
    lastActiveElementRef.current = document.activeElement;
    setSelectedCertificate(cert);
  }, []);

  const handleCloseViewer = useCallback(() => {
    setSelectedCertificate(null);
    // Restore keyboard focus to the triggering element
    if (lastActiveElementRef.current && typeof lastActiveElementRef.current.focus === "function") {
      setTimeout(() => {
        lastActiveElementRef.current.focus();
      }, 50);
    }
  }, []);

  return (
    <section
      id="accreditations"
      className="section-padding relative overflow-hidden"
      style={{ background: "#060B1F" }}
    >
      {/* Background Decorative Tech Elements */}
      <div className="absolute inset-0 tech-grid opacity-10 pointer-events-none" />
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[650px] h-[350px] rounded-full opacity-[0.10] blur-[130px] pointer-events-none"
        style={{ background: "radial-gradient(circle, #7C4DFF, #27B8FF)" }}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-10"
        >
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4"
            style={{ fontFamily: '"Space Grotesk", sans-serif' }}
          >
            Affiliation & <span className="gradient-text">Accreditation</span>
          </h2>

          <p className="text-slate-400 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Officially certified, registered, and compliant with national and global enterprise standards.
          </p>
        </motion.div>

        {/* Certificate Infinite Carousel */}
        <CertificateCarousel
          onSelectCertificate={handleSelectCertificate}
          isViewerOpen={!!selectedCertificate}
        />
      </div>

      {/* Lightbox Certificate Viewer */}
      {selectedCertificate && (
        <CertificateViewer
          certificate={selectedCertificate}
          onClose={handleCloseViewer}
        />
      )}
    </section>
  );
};

export default React.memo(AffiliationAccreditation);

